import { render } from "./AsPreloader.vue?vue&type=template&id=2fac5b5a&scoped=true&ts=true"
import script from "./AsPreloader.vue?vue&type=script&lang=ts"
export * from "./AsPreloader.vue?vue&type=script&lang=ts"

import "./AsPreloader.vue?vue&type=style&index=0&id=2fac5b5a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fac5b5a"]])

export default __exports__